var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1866 29.3333H9.8133C8.46553 29.2843 7.21005 28.636 6.38976 27.5655C5.56946 26.495 5.27005 25.1141 5.5733 23.8L5.8933 22.28C6.26134 20.2224 8.03013 18.7103 10.12 18.6667H21.88C23.9698 18.7103 25.7386 20.2224 26.1066 22.28L26.4266 23.8C26.7299 25.1141 26.4305 26.495 25.6102 27.5655C24.7899 28.636 23.5344 29.2843 22.1866 29.3333Z",
    fill: "#DAD6D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16H15.3333C12.3878 16 9.99996 13.6122 9.99996 10.6667V7.14668C9.99641 5.95742 10.4673 4.81585 11.3082 3.97491C12.1491 3.13398 13.2907 2.66312 14.48 2.66668H17.52C18.7092 2.66312 19.8508 3.13398 20.6917 3.97491C21.5327 4.81585 22.0035 5.95742 22 7.14668V10.6667C22 12.0812 21.4381 13.4377 20.4379 14.4379C19.4377 15.4381 18.0811 16 16.6666 16Z",
    fill: "#DAD6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.4f306a65db227a3f694c26c5fd2e53d6.svg";
export { ForwardRef as ReactComponent };